// Newest first. Bump `id` (sortable) whenever a release adds something users should notice.
export const RELEASES = [
  {
    id: "2026-06-c", title: "Latest update",
    items: [
      { h: "Export receipt searches", p: "Download any search or saved search as a spreadsheet, or as a PDF with every receipt photo, ready to share." },
      { h: "Month-by-month chart", p: "Every receipt search now shows a bar chart of its totals by month." },
      { h: "Household notes", p: "Leave short notes on bills and savings goals, signed with your name. They sync with your data." },
      { h: "January accountant reminder", p: "Each January the Dashboard reminds you to create last year's accountant pack and send it from your phone." },
    ],
  },
  {
    id: "2026-06-b", title: "June 2026 update",
    items: [
      { h: "User manual", p: "Tap ? next to any page title, or open User manual in the menu. Download it as a PDF too." },
      { h: "Screen tips", p: "Short tips point out the key buttons the first time you open each screen." },
      { h: "Sync reminder", p: "A gentle nudge if this device hasn't synced in a week, with a one-tap Send." },
      { h: "Receipt photos sync", p: "Photos now travel between devices as an encrypted file, locked with the same sync code." },
      { h: "Saved receipt searches", p: "Save searches like Home Depot this year, with date ranges, and see their total amount at a glance." },
    ],
  },
  {
    id: "2026-06-a", title: "Earlier in June",
    items: [
      { h: "Attach all exact matches", p: "Receipts with the same amount and date as one expense attach in one tap." },
      { h: "Search all receipts", p: "Find any receipt photo by store, amount or note." },
      { h: "Accountant pack", p: "One PDF with your tax pack, mileage log and receipt photos." },
      { h: "Sync devices", p: "Move data between phone and computers by scanning a QR code." },
    ],
  },
];

const KEY = "hb-whats-new-seen";
export const latestId = () => RELEASES[0].id;
// Releases this device hasn't seen; devices that never saw notes get only the latest
export function unseenReleases() {
  const seen = localStorage.getItem(KEY);
  return seen ? RELEASES.filter((r) => r.id > seen) : RELEASES.slice(0, 1);
}
export const markReleasesSeen = () => localStorage.setItem(KEY, latestId());
export const hasSeenAny = () => !!localStorage.getItem(KEY);
